var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-statistic-card"},_vm._l((5),function(index){return _c('batch-card-skeleton',{key:index})}),1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }